<template>
  <div class="text-left lg:pt-10 pt-4 md:pt-1 w-full">
    <h3 class="text-md pt-2 pb-3 font-serif uppercase">{{ $t("footer.newsletter") }}</h3>
    <div class="flex flex-col items-center md:items-left md:pr-6">
      <div class="flex flex-row border-b items-center w-full pb-2 mb-1">
        <input
          :placeholder="$t('footer.email')" :aria-label="$t('footer.email')" v-model="mail"
          class="flex justify-start w-full bg-transparent text-sm outline-none border border-transparent focus:border-white"
        />
        <button
          class="flex justify-end w-full text-xs text-bold" @click="readyToRegister">
            {{ $t("footer.signup") }}
        </button>
      </div>
      <div class="flex items-start pb-6 w-full pt-1">
        <input class="mt-1 md:mt-3 self-start" type="checkbox" v-model="privacyAccepted"
          aria-label="Checkbox to accept newsletter privacy policy" id="check" />
        <label
          class="text-xs text-left pl-1 md:pt-3 md:leading-none" :class="fontThin()" for="check">
            {{ $t("footer.privacy-newsletter") }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  data() {
    return {
      mail: '',

      privacyAccepted: false,
    };
  },

  watch: {
    authenticated() {
      this.mail = '';
      if (this.authenticated) {
        this.mail = this.user.email;
      }
    },
  },

  mounted() {
    if (this.authenticated) this.mail = this.user.email;
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),
  },

  methods: {
    readyToRegister() {
      if (this.privacyAccepted) {
        this.addToNewsletter();
      } else {
        this.createNotification('error', `${this.$t('notifications.newsletterAccept')}`);
      }
    },

    addToNewsletter() {
      axios({
        method: 'post',
        url: process.env.VUE_APP_SB_URL,
        withCredentials: false,
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          'api-key': process.env.VUE_APP_SB_KEY,
        },
        data: {
          email: this.mail,
          updateEnabled: false,
          includeListIds: [16],
          templateId: 11,
          redirectionUrl: process.env.VUE_APP_SB_REDIRECT,
        },
        json: true,
      }).then((response) => {
        if (response.status === 204 || response.status === 201) {
          this.createNotification('success', `${this.$t('notifications.newsletterSend')}`);
        }
      }).catch(() => {
        this.createNotification('error', `${this.$t('notifications.errorTryAgain')}`);
      });
    },

  },
};
</script>
